<template>
  <div class="listed-technologies">
    <ul class="listed-technologies-list flex">
      <li
        v-for="(element, i) in $props.elements"
        :key="`ListedTecnology-${i}`"
        class="listed-technologies-list-element flex"
      >
        <button
          @click="setStockState(i)"
          class="listed-technologies-list-element-more-cta"
          type="button"
          :disabled="!hasStock(element)"
        >
          <font-awesome-icon v-if="hasStock(element)" :icon="['fas', 'plus']" />
          <font-awesome-icon v-else :icon="['fas', 'check']" />
        </button>
        <div>
          <span>{{ element.name }}</span>
        </div>
        <div
          v-if="hasStock(element) && stockState.includes(i)"
          @focusout="setStockState(i)"
          :ref="`ListedTecnologyStock-${i}`"
          class="listed-technologies-list-element-stock"
          tabindex="-1"
        >
          <div class="listed-technologies-list-element-stock-container">
            <ul>
              <li v-for="(child, j) in element.stock" :key="`ListedTecnologyStock-${i}-${j}`">
                <span>{{ child }}</span>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ListedTechnologies",
  props: {
    /*
     * @property - elements
     * Sets elements of component
     */
    elements: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      stockState: []
    };
  },
  methods: {
    /*
     * @function - hasStock
     * true if element argument has stock in it, otherwise false
     * @param - element (Object) - element passed as argument
     */
    hasStock(element) {
      return element.stock && element.stock.length;
    },
    /*
     * @function - setStockState
     * If index passed is already part of stockState, then is removed (which means that is closed),
     * otherwise is pushed (which means that is opened)
     * @param - i (Number) - Index of current stock
     */
    setStockState(i) {
      if (this.stockState.includes(i)) {
        this.stockState.splice(this.stockState.indexOf(i), 1);
      } else {
        this.stockState.push(i);
        this.$nextTick(() => this.$refs[`ListedTecnologyStock-${i}`][0].focus());
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.listed-technologies {
  &-list {
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;

    &-element {
      flex: 1 0 100%;
      position: relative;

      @include breakpoint($xsmall) {
        flex: 1 0 50%;
      }

      @include breakpoint($large) {
        flex: 1 0 33.33333%;
      }

      @include breakpoint($xxlarge) {
        flex: 1 0 25%;
      }

      &-more-cta {
        @include fillVerticalTransition($white-raw, $dark-gray, $white-raw, $main-green, true);
        border: none;
        border-radius: 0.2rem;
        box-shadow: 0.2rem 0.2rem 0.25rem 0 rgba($dark-raw, 0.4);
        margin-right: 0.5rem;
        margin-top: 0.15rem;
        padding: 0;
        height: 1.3rem;
        width: 1.3rem;

        &::before {
          border-radius: 0.2rem;
        }

        &:disabled {
          opacity: 0.05;
          pointer-events: none;
        }
      }

      &-stock {
        @include boxShadow(0.65, true, false);
        background-color: $white-gray;
        border-radius: 0.25rem;
        bottom: 2.35rem;
        outline: none;
        position: absolute;
        width: 100%;
        z-index: 100;

        @include breakpoint($medium) {
          width: auto;
        }

        &::before {
          border-left: 0.5rem solid transparent;
          border-right: 0.5rem solid transparent;
          border-top: 0.5rem solid $white-gray;
          content: "";
          left: 0.65rem;
          position: absolute;
          bottom: -0.495rem;
        }

        &-container {
          max-height: 13.75rem;
          padding: 1rem 1.25rem 1rem 0;
          overflow: auto;
        }
      }
    }
  }
}
</style>
